export class SignupForm {
    public screenname: string = '';
    public firstname: string = '';
    public lastname: string = '';
    public email: string = '';
    public password: string = '';
    public confirm_password: string = '';
    public phone: string = '';
    public referral_code: string = '';

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/models/signup-form.ts